var exports = {
  "J": "x620889e6--342207--form-container",
  "t": "x620889e6--342207--title-container",
};

module.exports = exports;
